import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Building2 } from "lucide-react";

const FIELDS = [
  ["company_name", "Ragione sociale"], ["vat_number", "Partita IVA"], ["fiscal_code", "Codice fiscale"],
  ["address", "Indirizzo"], ["contact_name", "Referente"], ["email", "Email"], ["phone", "Telefono"],
  ["pec", "PEC"], ["sdi_code", "Codice SDI"],
];

export default function ClienteProfile() {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/cliente/me").then((r) => setC(r.data)); }, []);
  if (!c) return <div className="text-slate-500">Caricamento…</div>;
  return (
    <div className="space-y-6 max-w-3xl" data-testid="cliente-profile">
      <div>
        <h1 className="font-display text-3xl font-extrabold text-slate-900">Profilo Azienda</h1>
        <p className="text-slate-500 mt-1">Per modificare i dati aziendali contatta Centro Studi Athena.</p>
      </div>
      <Card className="border-slate-200"><CardContent className="p-6">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-12 h-12 rounded-xl bg-amber-50 border border-amber-200 flex items-center justify-center"><Building2 className="w-6 h-6 text-amber-600" /></div>
          <div>
            <div className="font-display text-xl font-bold">{c.company_name}</div>
            <div className="text-xs text-slate-500">{c.billing_mode === "slot" ? "Slot prepagati" : "Fatturazione mensile"}</div>
          </div>
        </div>
        <dl className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {FIELDS.map(([k, l]) => (
            <div key={k}>
              <dt className="text-xs uppercase tracking-widest font-bold text-slate-500">{l}</dt>
              <dd className="text-slate-900 mt-0.5" data-testid={`profile-${k}`}>{c[k] || "—"}</dd>
            </div>
          ))}
        </dl>
      </CardContent></Card>
    </div>
  );
}
